"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-pietro-in-amantea": {
    "d179393b": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "conocchia": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "924c2b70": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-colopera": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c87450c2": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "frossa": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "864b155b": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "mar-rosso": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24fd55e2": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "muschicella": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dc83f40f": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "santo-sperato": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f868f6e7": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "satn-elia": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87de982a": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "sciolle": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50694130": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "skipSearch": false
    }],
    "tuvolo": [{
      "hkey": "f107466c",
      "slug": "san-pietro-in-amantea",
      "name": "San Pietro in Amantea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;